import { render, staticRenderFns } from "./ratePlan.vue?vue&type=template&id=44852944&scoped=true"
import script from "./ratePlan.vue?vue&type=script&lang=js"
export * from "./ratePlan.vue?vue&type=script&lang=js"
import style0 from "./ratePlan.vue?vue&type=style&index=0&id=44852944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44852944",
  null
  
)

export default component.exports